import { ButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekButtonGroup = styled(ButtonGroup)(({ theme }) => ({}));

export { PeekButtonGroup, PeekButtonGroup as default };
